export default __webpack_public_path__ + "static/featured-bg-4b428fc28de7855fd0c5c9da40a6b8de.png";